import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-sources',
  templateUrl: './contact-sources.component.html',
  styleUrls: ['./contact-sources.component.scss']
})
export class ContactSourcesComponent {
}
